import type { OpenStatus, ShopInfo } from '../../lib/twin';
import { CtaButton } from './CtaButton';
import { OpenStatusBadge } from './OpenStatusBadge';

interface Props {
  shop: ShopInfo;
  status: OpenStatus;
  onOpenBot: () => void;
}

/** Footer — repeats CTAs, quick nav, and echoes the live open/closed status. */
export function SiteFooter({ shop, status, onOpenBot }: Props) {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-espresso-soft text-cream-100">
      <div className="mx-auto max-w-6xl px-5 py-14">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <p className="text-xl font-extrabold text-cream-50">{shop.name}</p>
            <p className="mt-2 text-sm">{shop.tagline}</p>
            <div className="mt-4">
              <OpenStatusBadge status={status} />
            </div>
          </div>

          <nav aria-label="Footer" className="text-sm">
            <p className="font-semibold text-cream-50">Explore</p>
            <ul className="mt-3 space-y-2">
              <li><a className="hover:underline" href="#menu">Menu</a></li>
              <li><a className="hover:underline" href="#hours">Hours &amp; location</a></li>
              <li><a className="hover:underline" href="#about">Our story</a></li>
              <li><a className="hover:underline" href="#top">Back to top</a></li>
            </ul>
          </nav>

          <div>
            <p className="text-sm font-semibold text-cream-50">Ready for a cup?</p>
            <div className="mt-3 flex flex-col gap-3">
              <CtaButton href="#menu" variant="primary">
                Order Now
              </CtaButton>
              <CtaButton
                onClick={onOpenBot}
                variant="secondary"
                ariaLabel="Ask our barista bot — opens a chat panel"
              >
                Ask our barista bot
              </CtaButton>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-cream-100/15 pt-6 text-sm text-foam">
          <p>
            © {year} {shop.name}. {shop.address_line}, {shop.city}, {shop.region}.
          </p>
          <p className="mt-1">
            Demo project for Cohort 1 — data is a client-side virtual twin, not a
            live store.
          </p>
        </div>
      </div>
    </footer>
  );
}
